import { login, useAuraUser } from '@nx/state';
import { isNonEmptyString, isNotNullish, isNullish } from '@nx/stdlib';
import { useEffect } from 'react';
import { Outlet, useSearchParams } from 'react-router';

export const SearchParamsGuard = () => {
  const { user } = useAuraUser();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    if (isNullish(user)) {
      return;
    }
    // Used to keep certain searchParams to use for accept invites
    const email = searchParams.get('email');
    const prompt = searchParams.get('prompt');
    const needsToAuthenticateWithAnotherUser = isNotNullish(email) && isNonEmptyString(email) && email !== user.email;
    if (isNotNullish(prompt) && needsToAuthenticateWithAnotherUser) {
      searchParams.delete('email');
      searchParams.delete('prompt');
      const searchParamsString = searchParams.toString();
      const searchString = isNonEmptyString(searchParamsString) ? `?${searchParamsString}` : '';
      void login(
        undefined,
        {
          state: {
            returnTo: `${location.pathname}${searchString}`,
          },
          extraQueryParams: {
            screen_hint: prompt,
          },
          login_hint: email,
          prompt: 'login',
        },
        needsToAuthenticateWithAnotherUser,
      );
    }
  }, [user, searchParams]);

  return <Outlet />;
};
